import React from 'react';

const FolderIcon = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_2242_29190"
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-1"
        width="18"
        height="18"
        style={{ maskType: 'alpha' }}
      >
        <rect x="-0.5" y="-0.5" width="17" height="17" fill="#D9D9D9" stroke="#025ECB" />
      </mask>
      <g mask="url(#mask0_2242_29190)">
        <path
          d="M14.6663 5.83341H15.1663V5.33341C15.1663 4.83309 14.9824 4.39233 14.6282 4.03819C14.2741 3.68406 13.8333 3.50008 13.333 3.50008H8.20678L7.40323 2.69653C7.23412 2.52742 7.03714 2.39631 6.81585 2.30474C6.59292 2.21249 6.3584 2.16675 6.11634 2.16675H2.66634C2.16601 2.16675 1.72525 2.35073 1.37112 2.70486C1.01699 3.05899 0.833008 3.49975 0.833008 4.00008V12.0001C0.833008 12.5004 1.01699 12.9412 1.37112 13.2953C1.72525 13.6494 2.16601 13.8334 2.66634 13.8334H12.6663C13.0624 13.8334 13.4282 13.713 13.7504 13.4807C14.0801 13.243 14.3076 12.9205 14.4276 12.5305L14.4286 12.5271L15.6286 8.52709L15.6286 8.5271L15.63 8.52244C15.7957 7.94996 15.6964 7.39929 15.3465 6.91544C14.9889 6.42091 14.4781 6.16675 13.8663 6.16675H5.26634C4.87033 6.16675 4.50453 6.28717 4.18227 6.51949C3.85258 6.75718 3.62512 7.07969 3.50512 7.46971L3.50511 7.4697L3.50414 7.47291L3.16634 8.59749V7.63342C3.16634 7.11452 3.35663 6.70369 3.75635 6.36479C4.1744 6.01036 4.65892 5.83341 5.23301 5.83341H14.6663Z"
          fill="#3591FE"
          stroke="#025ECB"
        />
      </g>
    </svg>
  );
};

export default FolderIcon;
